import { render, staticRenderFns } from "./HeaderBarMenu.vue?vue&type=template&id=6800981f&scoped=true"
import script from "./HeaderBarMenu.js?vue&type=script&lang=js&external"
export * from "./HeaderBarMenu.js?vue&type=script&lang=js&external"
import style0 from "./HeaderBarMenu.scss?vue&type=style&index=0&id=6800981f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800981f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLink: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Link/Link.vue').default})
